import React from "react";
import "./StatisticsWindow.css";
import GameWindowHeader from "../GameWindowHeader";
import GameTabViewUI from "../Tabs/GameTabViewUI";
import InGameValueCard from "../InGameValueCard";
import GameWindowBg from "../GameWindowBg";
import agent from "../../../agent";
import {MODER_ROLE_KEY} from "../../../constants/Constants";
import GameController from "../../../gameplay/controllers/GameController";
import GameData from "../../../gameplay/model/GameData";

export default class StatisticsWindow extends React.Component {
    constructor() {
        super();

        this.isAdmin = agent.user.role === MODER_ROLE_KEY;
        let teamId = this.isAdmin ? [] : agent.user.teamId;

        this.state = {
            gameData: null,
            currentPage: 0,
            teamId: teamId
        };
    }

    componentDidMount() {
        let currentGame = GameData.CurrentGame;
        if(currentGame.year > 0 && currentGame.state === 0){
            agent.GamePlay.stat(this.props.teamID, currentGame.year - 1, resp => {
                let data = GameData.CreateGameData(resp);
                this.setState({
                    gameData: data
                });
            })
        }
        else {
            this.setState({
                gameData: currentGame
            });
        }
    }

    openStatsPage(page) {
        this.setState({
            currentPage: page
        })
    }

    selectCurrentTeam(teamId) {
        this.setState({
            teamId
        });
    }

    getRightPage() {
        if(this.state.gameData === null) return "";
        let content = "";

        let stats =  GameController.calculateStatistics(this.state.gameData);

        switch (this.state.currentPage) {
            case 0:
                content = <div className="statistics__screen">
                    <div className="statistics__left">
                        <InGameValueCard title={"Объем перевезенных грузов (тонны нетто)"} value={stats.totalWeight} height={30} type={0} subtype={0} />

                        <InGameValueCard title={"ДОХОДЫ ОТ ПЕРЕВОЗОК + ПРОЧИЕ ДОХОДЫ"} value={stats.profit} height={30} type={0} subtype={0} />
                        <InGameValueCard title={"ПРОЧИЕ ДОХОДЫ"} value={stats.otherRevenue} height={30} type={0} subtype={0} />
                        <InGameValueCard title={"Переменные расходы"} height={30} type={0} subtype={0} />
                        <div className="table">
                            <InGameValueCard title={"Дизтопливо"} value={stats.dieselExpanses} height={30} type={1} subtype={1} />
                            <InGameValueCard title={"Электричество"} value={stats.electricityExpanses} height={30} type={1} subtype={2} />
                            <InGameValueCard title={"Итого переменные расходы"} value={stats.fuelExpanses} height={30} type={1} subtype={0} />
                        </div>

                        <InGameValueCard title={"ВАЛОВАЯ ПРИБЫЛЬ"} value={stats.valProfit} height={30} type={0} subtype={0} />

                        <InGameValueCard title={"Операционные расходы"} height={30} type={0} subtype={0} />
                        <div className="table">
                            <InGameValueCard title={"Персонал"} value={stats.brigadesExpanses} height={30} type={1} subtype={1} />
                            <InGameValueCard title={"Сверхурочные и подрядчики"} value={stats.contractorsExpenses} height={30} type={1} subtype={2} />
                            <InGameValueCard title={"Материалы для ремонта"} value={stats.partsExpanses} height={30} type={1} subtype={1} />
                            <InGameValueCard title={"Услуги связи"} value={stats.communicationExpanses} height={30} type={1} subtype={2} />
                            <InGameValueCard title={"Прочие операционные расходы"} value={stats.otherExpanses} height={30} type={1} subtype={1} />
                            <InGameValueCard title={"Безопасность"} value={stats.securityExpanses} height={30} type={1} subtype={2} />
                            <InGameValueCard title={"Итого операционные расходы"} value={stats.operationsSum} height={30} type={1} subtype={0} />
                        </div>
                    </div>
                    <div className="statistics__right">
                        <InGameValueCard title={"EBITDA"} value={stats.EBITDA} height={30} type={0} subtype={0} />
                        <div className="table">
                            <InGameValueCard title={"Амортизация"} value={stats.depreciation} height={30} type={1} subtype={1} />
                        </div>

                        <InGameValueCard title={"ОПЕРАЦИОННАЯ ПРИБЫЛЬ"} value={stats.operationalProfit} height={30} type={0} subtype={0} />
                        <div className="table">
                            <InGameValueCard title={"Проценты по займам"} value={stats.creditPercents} height={30} type={1} subtype={1} />
                        </div>

                        <InGameValueCard title={"ПРИБЫЛЬ ДО НАЛОГОВ"} value={stats.beforeTaxesProfit} height={30} type={0} subtype={0} />
                        <div className="table">
                            <InGameValueCard title={"Налог (30%)"} value={stats.afterTaxesProfit} height={30} type={1} subtype={1} />
                        </div>

                        <InGameValueCard title={"ЧИСТАЯ ПРИБЫЛЬ"} value={stats.cleanProfit} height={30} type={0} subtype={0} />
                        <div className="table">
                            <InGameValueCard title={"Нераспределенная прибыль предыдущего года"} value={stats.lastYearProfit} height={30} type={1} subtype={1} />
                            <InGameValueCard title={"Чистая прибыль"} value={stats.cleanProfit} height={30} type={1} subtype={2} />
                            <InGameValueCard title={"Нераспределенная прибыль этого года"} value={stats.lastYearProfit + stats.cleanProfit} height={30} type={1} subtype={1} />
                        </div>
                    </div>
                </div>;
                break;
            case 2:
                content = <div className="statistics__screen">
                    <div className="statistics__left">
                        <InGameValueCard title={"АКТИВЫ"} height={30} type={0} subtype={0} />

                        <InGameValueCard title={"основные средства"} value={stats.main} height={30} type={0} subtype={0} />

                        <InGameValueCard title={"основные средства (остаточная стоимость)"} value={stats.mainLeft} height={30} type={0} subtype={0} />

                        <InGameValueCard title={"ОБОРОТНЫЕ СРЕДСТВА"} height={30} type={0} subtype={0} />
                        <div className="table">
                            <InGameValueCard title={"Запасы/Запчасти"} value={stats.partsSum} height={30} type={1} subtype={1} />
                            <InGameValueCard title={"Дебиторская задолженность"} value={stats.debit} height={30} type={1} subtype={2} />
                            <InGameValueCard title={"Наличные"} value={stats.cash} height={30} type={1} subtype={1} />
                        </div>
                        <div className="filler table" style={{marginBottom: "30px"}}>
                            <InGameValueCard title={"ОБОРОТНЫЕ СРЕДСТВА"}  value={stats.money} height={30} type={1} subtype={0} />
                        </div>

                        <InGameValueCard title={"активы"} value={stats.actives} height={30} type={0} subtype={0} />

                        <InGameValueCard title={"чистые заимствования"} value={stats.cleanCredit} height={30} type={0} subtype={0} />

                        <InGameValueCard title={"долговая нагрузка"} value={`${stats.debtPercent}%`} height={30} type={0} subtype={0} />
                    </div>
                    <div className="statistics__right">
                        <InGameValueCard title={"ПАССИВЫ"} height={30} type={0} subtype={0} />

                        <InGameValueCard title={"задолженность"} height={30} type={0} subtype={0} />
                        <div className="table">
                            <InGameValueCard title={"Кредиты и займы"} value={stats.credit} height={30} type={1} subtype={1} />
                            <InGameValueCard title={"Кредиторская задолженность"} value={stats.creditDebt} height={30} type={1} subtype={2} />
                            <InGameValueCard title={"ВСЕГО ОБЯЗАТЕЛЬСТВА"} value={stats.creditsSum} height={30} type={1} subtype={0} />
                        </div>

                        <InGameValueCard title={"СОБСТВЕННЫЙ КАПИТАЛ"} height={30} type={0} subtype={0} />
                        <div className="table">
                            <InGameValueCard title={"Акционерный капитал"} value={stats.funders} height={30} type={1} subtype={1} />
                            <InGameValueCard title={"Нераспределенная прибыль"} value={stats.lastYearProfitBalance} height={30} type={1} subtype={2} />
                            <InGameValueCard title={"ВСЕГО СОБСТВЕННЫЙ КАПИТАЛ"} value={stats.fullCapital} height={30} type={1} subtype={0} />
                        </div>

                        <InGameValueCard title={"пассивы"} value={stats.passives} height={30} type={0} subtype={0} />

                        <InGameValueCard title={"чистый оборотный капитал"} value={stats.cleanCapital} height={30} type={0} subtype={0} />

                        <InGameValueCard title={"заёмная возможность"} value={stats.debtAbility} height={30} type={0} subtype={0} />
                    </div>
                </div>;
                break;
            case 1:
                content = <div className="statistics__screen">
                    <div className="statistics__left">
                        <div className="table">
                            <InGameValueCard title={"Грузооборот (т)"} value={stats.deliveredCargo} height={30} type={1} subtype={1} />
                            <InGameValueCard title={"Удовлетворённость клиентов (уголь) (ед.)"} value={stats.npsCoal} height={30} type={1} subtype={2} />
                            <InGameValueCard title={"Удовлетворённость клиентов (остальное) (ед.)"} value={stats.npsOther} height={30} type={1} subtype={1} />
                            <InGameValueCard title={"Накопленный опыт (уголь) (ед.)"} value={stats.expCoal} height={30} type={1} subtype={2} />
                            <InGameValueCard title={"Накопленный опыт (остальное) (ед.)"} value={stats.expOther} height={30} type={1} subtype={1} />
                        </div>

                        <InGameValueCard title={"коэффициент оборачиваемости"} height={30} type={0} subtype={0} />
                        <div className="table">
                            <InGameValueCard title={"Дебиторская задолженность (дней)"} value={isFinite(stats.debtDays) ? stats.debtDays : "-"} height={30} type={1} subtype={1} />
                            <InGameValueCard title={"Запасов и материалов (дней)"} value={isFinite(stats.partsDays) ? stats.partsDays : "-"} height={30} type={1} subtype={2} />
                            <InGameValueCard title={"Кредиторской задолженности (дней)"} value={isFinite(stats.creditDays) ? stats.creditDays : "-"} height={30} type={1} subtype={1} />
                            <InGameValueCard title={"Основных средств (лет)"} value={stats.capitalYears} height={30} type={1} subtype={2} />
                            <InGameValueCard title={"Всех активов (лет)"} value={isFinite(stats.allActives) ? stats.allActives : "-"} height={30} type={1} subtype={1} />
                        </div>

                        <InGameValueCard title={"коэффициент рентабельности"} height={30} type={0} subtype={0} />
                        <div className="table">
                            <InGameValueCard title={"Возврат на активы (ROA)"} value={stats.ROA} height={30} type={1} subtype={1} />
                            <InGameValueCard title={"Возврат на собственный капитал (ROE)"} value={stats.ROE} height={30} type={1} subtype={2} />
                            <InGameValueCard title={"Возврат на прим. капитал (ROCE)"} value={isFinite(stats.ROCE) ? stats.ROCE + "%" : "-"} height={30} type={1} subtype={1} />
                        </div>

                    </div>
                    <div className="statistics__right">
                        <div className="table">
                            <InGameValueCard title={"Уровень безопасности"} value={stats.securityLevel} height={30} type={1} subtype={1} />
                            <InGameValueCard title={"Инвестиции в оборудование (руб.)"} value={stats.investments} height={30} type={1} subtype={2} />
                            <InGameValueCard title={"Получение/возврат кредита (руб.)"} value={stats.receivedDebt} height={30} type={1} subtype={1} />
                        </div>

                        <InGameValueCard title={"коэффициент прибыльности"} height={30} type={0} subtype={0} />
                        <div className="table">
                            <InGameValueCard title={"Средняя цена за тонну (руб.)"} value={isFinite(stats.avgTonnage) ? stats.avgTonnage : "-"} height={30} type={1} subtype={1} />
                            <InGameValueCard title={"GrossMargin (%)"} value={isFinite(stats.grossMargin) ? stats.grossMargin + "%" : "-"} height={30} type={1} subtype={2} />
                            <InGameValueCard title={"EBITDA (%)"} value={stats.EBITDAPercent} height={30} type={1} subtype={1} />
                            <InGameValueCard title={"Operating Profit (%)"} value={isFinite(stats.operatingProfit) ? stats.operatingProfit + "%" : "-"} height={30} type={1} subtype={2} />
                            <InGameValueCard title={"NetProfit (%)"} value={isFinite(stats.netProfit) ? stats.netProfit + "%": "-"} height={30} type={1} subtype={1} />
                        </div>

                        <InGameValueCard title={"коэффициент использования трудозатрат"} height={30} type={0} subtype={0} />
                        <div className="table">
                            <InGameValueCard title={"Коэффициент использования трудозатрат"}
                                             value={isFinite(stats.brigadesUsage) ? Math.round(stats.brigadesUsage * 100) + "%" : "-" }
                                             height={30} type={1} subtype={1} />
                            <InGameValueCard title={"Неиспользованные трудозатраты (ед.)"} value={stats.unusedBrigades} height={30} type={1} subtype={2} />
                            <InGameValueCard title={"Неиспользованные трудозатраты (руб.)"} value={stats.unusedMoney} height={30} type={1} subtype={1} />
                            <InGameValueCard title={"Коэффициент использования локомотивов"} value={stats.locoUsage} height={30} type={1} subtype={2} />
                            <InGameValueCard title={"Коэффициент порожнего пробега"} value={stats.emptyMilesPercent} height={30} type={1} subtype={1} />
                        </div>
                    </div>
                </div>;
                break;
            default:
                break;
        }

        return content;
    }

    render() {
        let content = this.getRightPage();
        let allStats = ["Отчёт о прибылях и убытках", "Ключевые показатели деятельности",  "Балансовый отчёт"]
        let shortStats = ["Отчёт о прибылях и убытках"]
        return <div className="statistics container__shadow">
            <div className="statistics__content container__content">
                <GameWindowHeader title="Статистика" isClosable={true} onHide={this.props.onHide}
                                  width={1084} height={40}/>
                <div className="statistics__body">
                    <GameTabViewUI width={1064}
                                   tabs={GameData.CurrentGame.state === 0 && !GameData.CurrentGame.isInvestComplete
                                   && GameData.CurrentGame.year !== 0 ? allStats : shortStats}
                                   onSelectedIndex={this.openStatsPage.bind(this)} />
                    <GameWindowBg width={1064} height={610} value={content} />
                </div>
            </div>
        </div>
    }
}
